import React, { memo } from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'

import './slide-instruction-model.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import { LOCALE } from '../../../constants/activity-constants'

function NextArrow(props) {
  const { onClick } = props
  pushEventDataLayer(
    'Interacciones - 360',
    'Cur-v',
    'Click',
    'Rotación Derecha'
  )
  return (
    <div
      className={'f-slide-instructions__arrow arrow-next'}
      onClick={onClick}
    />
  )
}

function PrevArrow(props) {
  const { onClick } = props
  pushEventDataLayer(
    'Interacciones - 360',
    'Cur-v',
    'Click',
    'Rotación Izquierda '
  )

  return (
    <div className="f-slide-instructions__arrow arrow-prev" onClick={onClick} />
  )
}

const SlideInstructionModel = memo(() => {
  const settings = {
    autoplay: false,
    speed: 3000,
    autoplaySpeed: 6000,
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  const getInstructions = () => {
    switch (LOCALE) {
      case 'es-CO':
        return [
          'Haz clic en sus zonas y descubre sus características',
          'Mueve la toalla y conoce Cur-V ®',
        ]
      case 'es-AR':
      case 'es-PY':
      case 'es-UY':
        return [
          'Hacé clic en sus zonas y descubrí sus características',
          'Mové la toalla y conocé la tecnología Cur-V ®',
        ]
      default:
        return [
          'Haz clic en sus zonas y descubre sus características',
          'Mueve la toalla y conoce Cur-V ®',
        ]
    }
  }

  return (
    <div className="f-slide-instructions">
      <Slider {...settings}>
        {getInstructions().map((item, i) => {
          return (
            <p
              key={`instruction-${i}`}
              className="f-slide-instructions__instruction"
            >
              {item}
            </p>
          )
        })}
      </Slider>
    </div>
  )
})

export default SlideInstructionModel
